import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { EASE } from "@/components/Reveal";

const RadioIcon = ({ className = "h-4 w-4", stroke = "#4e5155" }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" className={className}>
    <path d="M3 10a5 5 0 0 1 10 0" stroke={stroke} strokeWidth="1.4" strokeLinecap="round" />
    <rect x="2.5" y="10" width="3" height="4" rx="1" fill={stroke} />
    <rect x="10.5" y="10" width="3" height="4" rx="1" fill={stroke} />
  </svg>
);

export const TrackBadge = ({ track }) => (
  <span className="absolute right-3 top-3 rounded-full bg-white/95 px-3 py-1 text-[11px] uppercase leading-[16px] tracking-[0.14em] text-charcoal font-display">
    {track}
  </span>
);

const EpisodeCard = ({ episode, index = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, ease: EASE, delay: 0.05 * index }}
    className="h-full"
  >
    <Link
      to={`/episodes/${episode.id}`}
      data-testid={`episode-card-${episode.id}`}
      aria-label={`${episode.title} — open episode`}
      className="group relative flex h-full w-full flex-col overflow-hidden rounded-2xl border border-hairline bg-white transition-all duration-500 ease-out cursor-pointer hover:-translate-y-1 hover:border-silver hover:shadow-[0_24px_60px_-32px_rgba(78,81,85,0.35)]"
    >
      <div className="relative h-[194px] w-full overflow-hidden">
        <div className="absolute inset-0 transition-transform duration-[900ms] group-hover:scale-[1.07]" style={{ transitionTimingFunction: "cubic-bezier(0.22,1,0.36,1)" }}>
          <img alt={episode.imageAlt || "Episode artwork"} className="h-full w-full object-cover" src={episode.image} />
        </div>
        <div aria-hidden="true" className="pointer-events-none absolute inset-0 bg-linen opacity-0 mix-blend-multiply transition-opacity duration-500 group-hover:opacity-25" />
        <span className="absolute left-3 top-3 grid h-8 w-8 place-items-center rounded-lg bg-white shadow-sm">
          <RadioIcon />
        </span>
        <TrackBadge track={episode.track} />
      </div>
      <div className="flex flex-1 flex-col px-6 py-7">
        <p className="text-[12.5px] leading-[22.4px] text-charcoal-mid">Episode {episode.number}</p>
        <h3 className="mt-2 font-display text-[22px] leading-[1.25] text-black sm:text-[24px]">{episode.title}</h3>
        <span className="mt-auto pt-4 font-display text-[14px] leading-[22.4px] text-charcoal underline decoration-silver underline-offset-4 transition-colors group-hover:text-black group-hover:decoration-black">
          Open episode
        </span>
      </div>
    </Link>
  </motion.div>
);

export default EpisodeCard;
